// 将所有svg导入到icons/index.js中
const requireAll = requireContext => requireContext.keys().map(requireContext);
const req = require.context(".", true, /\.svg$/);
requireAll(req);